import { render, staticRenderFns } from "./SenderAddressModal.vue?vue&type=template&id=2c32974d"
import script from "./SenderAddressModal.vue?vue&type=script&lang=js"
export * from "./SenderAddressModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports